import React from 'react';
import { defineBlock, useEditor, smartProps, EditableHeading } from '@smartfire/gutenberg-react';
import {ReactComponent as Trash} from '../assets/icons/trash.svg';
import {ReactComponent as Add} from '../assets/icons/add.svg';
import { MediaUpload, MediaUploadCheck, RichText } from '@wordpress/block-editor';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import SwiperCore, {Autoplay, Navigation} from 'swiper';
import style from './block.module.scss';
import clsx from 'clsx';

const ALLOWED_MEDIA_TYPES = ['image'];

function Block({ slides }) {
    const {isEditing, updateData} = useEditor();

    SwiperCore.use([
        Autoplay,
        Navigation
    ])

    const navigationPrevRef = React.useRef(null);
    const navigationNextRef = React.useRef(null);

    const updateValue = (key, value, i) => {
        slides[i][key] = value;
        updateData({slides: [...slides]});
    }

    const addSlide = () => {
        let newSlide = {
            image: "",
            link: "",
            order: 0,
        };
        updateData({slides: [...slides, newSlide]});
    }

    const deleteSlide = (i) => {
        slides.splice(i, 1);
        updateData({slides: [...slides]});
    }

    const SlidesAdmin = () => {
        return (
            <div className={style.contentAdmin}>
                {slides && slides.map((item, i) => {
                    return <div className={style.admin} key={i}>
                        <button className={style.deleteButton} onClick={() => deleteSlide(i)}>
                            <Trash />
                        </button>
                        <div className={style.contentSlide}>
                            <RichText
                                tagName="div"
                                placeholder={'Lien site partenaire'}
                                value={item.link}
                                className={style.link}
                                onChange={(value) => updateValue('link', value, i)}
                            />
                            <MediaUploadCheck>
                            <img src={item.image.url} alt={item.image.description} />
                            <MediaUpload 
                                    allowedTypes={ALLOWED_MEDIA_TYPES}
                                    value={item.image ? item.image.id : null}
                                    render={({ open }) => (
                                        <button className={style.buttonImage} onClick={open}>Changer l'image</button>
                                    )}
                                    onSelect={ (media) => updateValue('image', media, i)}
                                />
                            </MediaUploadCheck>
                            <p>Position du partenaire dans le carousel :</p>
                            <RichText
                                tagName="span"
                                placeholder={'Entrez un nombre'}
                                value={item.order}
                                className={style.order}
                                onChange={(value) => updateValue('order', value, i)}
                            />
                        </div>
                    </div>
                })}
                <button className={style.addButton} onClick={() => addSlide()}>
                    <Add />
                </button>
            </div>
        )
    }

    return (
        <div className={style.block}>
            <EditableHeading 
                smartProp={"title"}
                placeholder={"Insérez le titre"}
                className={style.title}
            />
            {isEditing ?
                <>
                    {SlidesAdmin()}
                </>
            :
                <Swiper
                    className={style.swiper}
                    slidesPerView={window.innerWidth <= parseInt(style.desktopBreakpoint) ? (window.innerWidth <= parseInt(style.mobileBreakpoint) ? 2 : 3 ): 4}
                    loop={slides.length > 4 ? true : false}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false
                    }}
                    navigation={{
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current,
                    }}
                >
                    {slides.sort((a, b) => a.order - b.order).map((item, i) => {
                        return <SwiperSlide key={i}>
                            <a href={item.link ? item.link : null}>
                                <img src={item.image.url} alt={item.image.alt} className={clsx(style.logo, item.link && style.logoHover)} />
                            </a>
                        </SwiperSlide>
                    })}
                    {slides.length > 4 &&
                        <>
                            <div className={style.arrow} ref={navigationPrevRef} />
                            <div className={clsx(style.arrow, style.right)} ref={navigationNextRef} />
                        </>                    
                    }
                </Swiper>
            }
        </div>
    )
}

export default defineBlock({
    Block, 
    smartProps: {
        slides: smartProps.any.withDefault([]),
        title: smartProps.object.withDefault({
            headingLevel: 2,
        }),
    },
    setup: {
        title: 'Carrousel partenaires',
    }
})